export const DELETE_RULE = 'DELETE_RULE';
export const DELETE_RULE_SUCCESS = 'DELETE_RULE_SUCCESS';
export const DELETE_RULE_FAILURE = 'DELETE_RULE_FAILURE';
export const OPEN_DELETE_RULE_POP_UP = 'OPEN_DELETE_RULE_POP_UP';
export const CLOSE_DELETE_RULE_POP_UP = 'CLOSE_DELETE_RULE_POP_UP';
